import React  , { Component } from 'react';

import { HomeSlider, HomeTitle , FaqItem } from '../../Components/UI/UI';

import {getWeather} from '../../Utility/Utility';
import Menu from '../../Components/Menu/Menu';
import Footer from '../../Components/Footer/Footer';

import './ContactUs.css';
import "../innerPage.css"




class ContactUs extends Component {

  state = {
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }



  componentDidMount () {

    getWeather((Weather)=>{
      
      console.log("Weather", Weather);
      this.setState({
        telAvivWeather : Weather.telAvivWeather,
        waterTemp : Weather.water_temp,
        jerusalemWeather : Weather.jerusalemWeather,
      })

      
    });
    

     
  }
  
  render(){
   
    return(
      <div className="page align-center page-FAQ inner-page page-infoforpastors">
        <Menu />
        <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
        <div className="container">
           <HomeTitle>
           Contact Us
            </HomeTitle>
            <div className="clear"></div>
            
            <div className="contact-us-wrapper">
            <table>
              <tr>
                <th>New York</th>
                <td>1-646-779-6766</td><td> <a href="mailto:Info-NY@goisrael.gov.il">Info-NY@goisrael.gov.il</a></td>
              </tr>
              <tr>
                <th>Los Angeles</th><td>1-323-658-7463</td><td> <a href="mailto:igtolosangeles@goisrael.gov.il">igtolosangeles@goisrael.gov.il</a></td>
              </tr>
              <tr>
                <th>Atlanta</th>
                <td>1-404-541-2770</td><td> <a href="mailto:Atlanta@goisrael.gov.il">Atlanta@goisrael.gov.il</a></td>
              </tr>
              <tr>
                <th>Chicago</th>
                <td>1-312-803-7078</td><td> <a href="mailto:igtochicago@goisrael.gov.il">igtochicago@goisrael.gov.il</a></td>
              </tr>
              <tr>
                <th>Canada</th>
                <td>1-416-964-3784</td><td> <a href="mailto:igtocanada@goisrael.goil">igtocanada@goisrael.goil</a></td>
              </tr>
              <tr>
                <th>London</th>
                <td>4-207-299-1100</td><td> <a href="mailto:Info-uk@goisrael.gov.il">Info-uk@goisrael.gov.il</a></td>
              </tr>
              <tr>
                <th>Nordic Countries</th>
                <td>6-8239209</td><td> <a href="mailto:director-se@goisrael.gov.il">director-se@goisrael.gov.il</a></td>
              </tr>
              <tr>
                <th>Netherlands</th>
                <td>1-20-616-1948</td><td> <a href="mailto:info-nl@goisrael.gov.il">info-nl@goisrael.gov.il</a></td>
              </tr>
              <tr>
                <th>India</th>
                <td>91-22-6137 0700</td><td> <a href="mailto:info-Israel@goisrael.gov.il">info-Israel@goisrael.gov.il</a></td>
              </tr>
            </table>



            </div>
            <div className="clear"></div>
        </div>
        <Footer />
      </div>
    )
  }

}



export default ContactUs


// WEBPACK FOOTER //
// ./src/Pages/ContactUs/ContactUs.js